import { createContext } from 'react'
import { IOptionsContext } from '@elastic-suite/gally-admin-shared'
export const optionsContext = createContext<IOptionsContext>(null)
